import React, { useState } from 'react';
import PricingCard from '../components/PricingCard';

export default function PricingPage() {
  const [annual, setAnnual] = useState(false);
  
  // Preise (monatlich)
  const prices = {
    basic: {
      monthly: 0,
      annual: 0,
    },
    premium: {
      monthly: 9.99,
      annual: 7.99,
    },
    professional: {
      monthly: 19.99,
      annual: 15.99,
    },
  };

  return (
    <div className="bg-gray-50">
      <div className="pt-12 sm:pt-16 lg:pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
              Preise für jedes Bedürfnis
            </h2>
            <p className="mt-4 text-xl text-gray-600">
              Wähle den Plan, der am besten zu dir passt.
            </p>
          </div>
        </div>
      </div>
      
      <div className="mt-8 pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
        <div className="relative">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Toggle jährlich/monatlich */}
            <div className="flex justify-center mb-8">
              <div className="relative bg-white rounded-lg p-1 flex">
                <button
                  onClick={() => setAnnual(false)}
                  className={`${
                    !annual
                      ? 'bg-primary-500 text-white'
                      : 'text-gray-700 hover:bg-gray-50'
                  } relative py-2 px-6 border-transparent rounded-md text-sm font-medium whitespace-nowrap focus:outline-none focus:z-10 transition-colors duration-200 ease-in-out`}
                >
                  Monatlich
                </button>
                <button
                  onClick={() => setAnnual(true)}
                  className={`${
                    annual
                      ? 'bg-primary-500 text-white'
                      : 'text-gray-700 hover:bg-gray-50'
                  } ml-1 relative py-2 px-6 border-transparent rounded-md text-sm font-medium whitespace-nowrap focus:outline-none focus:z-10 transition-colors duration-200 ease-in-out`}
                >
                  Jährlich <span className="text-xs font-normal">(-20%)</span>
                </button>
              </div>
            </div>
            
            <div className="relative mt-8 max-w-2xl mx-auto lg:max-w-none lg:mx-0">
              <div className="grid lg:grid-cols-3 gap-8">
                {/* Basic Plan */}
                <PricingCard
                  title="Basic"
                  price={prices.basic[annual ? 'annual' : 'monthly']}
                  description="Für Gelegenheitsnutzer, die die grundlegenden Funktionen ausprobieren möchten."
                  features={[
                    'Bis zu 5 Bilder pro Monat',
                    'Grundlegende Makeup-Entfernungs-KI',
                    'Webbasierter Zugriff',
                    'Standardauflösung',
                    'Community-Support'
                  ]}
                  buttonText="Kostenlos starten"
                  buttonLink="/demo"
                  highlighted={false}
                />
                
                {/* Premium Plan */}
                <PricingCard
                  title="Premium"
                  price={prices.premium[annual ? 'annual' : 'monthly']}
                  description="Für Einzelpersonen, die regelmäßig unsere fortschrittlichen Funktionen nutzen möchten."
                  features={[
                    'Bis zu 100 Bilder pro Monat',
                    'Erweiterte Makeup-Entfernungs-KI',
                    'Webbasierter Zugriff',
                    'HD-Auflösung',
                    'Vorrang-Support',
                    'Batch-Verarbeitung',
                    'Keine Wasserzeichen'
                  ]}
                  buttonText="Premium wählen"
                  buttonLink="/dashboard"
                  highlighted={true}
                />
                
                {/* Professional Plan */}
                <PricingCard
                  title="Professional"
                  price={prices.professional[annual ? 'annual' : 'monthly']}
                  description="Für Profis, die unsere Technologie für kommerzielle Zwecke einsetzen."
                  features={[
                    'Unbegrenzte Bilder',
                    'Hochmoderne Makeup-Entfernungs-KI',
                    'Desktop-App + API-Zugang',
                    '4K-Auflösung',
                    'Dedizierter Support',
                    'Erweiterte Batch-Verarbeitung',
                    'Kommerzielle Nutzungsrechte'
                  ]}
                  buttonText="Kontaktiere uns"
                  buttonLink="/contact"
                  highlighted={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* FAQ Section */}
      <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center">
          Häufig gestellte Fragen
        </h2>
        <div className="mt-12">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12">
            <div>
              <dt className="text-lg leading-6 font-medium text-gray-900">
                Wie unterscheiden sich die verschiedenen Pläne in der Qualität?
              </dt>
              <dd className="mt-2 text-base text-gray-500">
                Der Basic-Plan verwendet unser Basis-KI-Modell, während Premium und Professional fortschrittlichere Algorithmen mit höherer Genauigkeit und besserer Hauttonrekonstruktion bieten.
              </dd>
            </div>
            <div>
              <dt className="text-lg leading-6 font-medium text-gray-900">
                Kann ich meinen Plan später upgraden?
              </dt>
              <dd className="mt-2 text-base text-gray-500">
                Ja, du kannst jederzeit von einem Plan zu einem höheren wechseln. Dein Guthaben wird anteilig auf den neuen Plan angerechnet.
              </dd>
            </div>
            <div>
              <dt className="text-lg leading-6 font-medium text-gray-900">
                Was passiert, wenn ich mein monatliches Bildlimit erreiche?
              </dt>
              <dd className="mt-2 text-base text-gray-500">
                Im Basic- und Premium-Plan kannst du entweder auf den nächsten Monat warten oder ein Upgrade auf einen höheren Plan durchführen, um mehr Bilder zu verarbeiten.
              </dd>
            </div>
            <div>
              <dt className="text-lg leading-6 font-medium text-gray-900">
                Gibt es eine Geld-zurück-Garantie?
              </dt>
              <dd className="mt-2 text-base text-gray-500">
                Ja, wir bieten eine 14-tägige Geld-zurück-Garantie für alle bezahlten Pläne. Wenn du mit unserem Service nicht zufrieden bist, erhältst du eine volle Rückerstattung.
              </dd>
            </div>
            <div>
              <dt className="text-lg leading-6 font-medium text-gray-900">
                Was bedeutet "kommerzielle Nutzungsrechte"?
              </dt>
              <dd className="mt-2 text-base text-gray-500">
                Mit dem Professional-Plan darfst du die von unserer KI erzeugten Bilder in kommerziellen Projekten wie Werbung, Websites oder Publikationen verwenden.
              </dd>
            </div>
            <div>
              <dt className="text-lg leading-6 font-medium text-gray-900">
                Kann ich den Dienst kündigen?
              </dt>
              <dd className="mt-2 text-base text-gray-500">
                Natürlich. Du kannst deinen bezahlten Plan jederzeit in deinem Konto kündigen. Die Kündigung wird am Ende deiner aktuellen Abrechnungsperiode wirksam.
              </dd>
            </div>
          </dl>
        </div>
      </div>
      
      {/* CTA Section */}
      <div className="bg-primary-700">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-24 lg:px-8 lg:flex lg:items-center lg:justify-between">
          <h2 className="text-3xl font-extrabold tracking-tight text-white md:text-4xl">
            <span className="block">Bereit, loszulegen?</span>
            <span className="block text-primary-300">Starte heute mit NaturalMe.</span>
          </h2>
          <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
            <div className="inline-flex rounded-md shadow">
              <a
                href="/demo"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-primary-600 bg-white hover:bg-primary-50"
              >
                Kostenlos starten
              </a>
            </div>
            <div className="ml-3 inline-flex rounded-md shadow">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500"
              >
                Kontaktiere uns
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}